module.exports = __webpack_public_path__ + "img/bg2.f42d0cad.jpg";